const STEPS = 7

const clampRatio = (value: number): number => {
  if (!Number.isFinite(value)) return 0
  return Math.min(1, Math.max(0, value))
}

export const ConfidenceMeter = ({ value, label }: { value: number; label: string }) => {
  const ratio = clampRatio(value)
  const percent = Math.round(ratio * 100)
  const filled = Math.round(ratio * STEPS)

  return (
    <span className="confidence" role="img" aria-label={`${label} ${percent}%`}>
      <span className="confidence-bars" aria-hidden="true">
        {Array.from({ length: STEPS }, (_, index) => (
          <i key={index} className={index < filled ? 'confidence-bar confidence-bar-on' : 'confidence-bar'} />
        ))}
      </span>
      <span className="confidence-value num" aria-hidden="true">
        {percent}%
      </span>
    </span>
  )
}
